import { List, ListRow, todayIso } from '@ui';
import { useTranslation } from 'react-i18next';
import { formatDate } from '../../../lib/format';
import type { MarketDayListItem } from '../api';
import { timesText } from './scheduleText';

function addDays(iso: string, days: number): string {
  const d = new Date(`${iso}T12:00:00`);
  d.setDate(d.getDate() + days);
  return d.toLocaleDateString('sv-SE');
}

/** "Heute: Wochenmarkt" – the market days I stand at, soonest first (MKT-016). */
export function MyMarketDays({ days }: { days: readonly MarketDayListItem[] }) {
  const { t } = useTranslation();
  const today = todayIso();
  const tomorrow = addDays(today, 1);
  return (
    <List>
      {days.map((d) => {
        const times = timesText(t, d.starts_at, d.ends_at);
        const details = [times, d.place].filter(Boolean).join(' · ');
        return (
          <ListRow
            key={d.id}
            href={`/verkauf/markttage/${d.id}`}
            title={
              d.held_on === today
                ? t('sales.markets.mine.today', { name: d.name })
                : d.held_on === tomorrow
                  ? t('sales.markets.mine.tomorrow', { name: d.name })
                  : t('sales.markets.mine.on', { date: formatDate(d.held_on), name: d.name })
            }
            description={details || undefined}
          />
        );
      })}
    </List>
  );
}
